export default __webpack_public_path__ + "images/LS.65d4d8b.png";